import clsx from 'clsx'
import {PropsWithChildren, ReactNode} from 'react'
import {HeaderProps} from 'react-table'
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import {getSortIcon} from '../../Functional'
import CustomTooltip from '../../../../_metronic/tooltip/CustomTooltip'
import FAIcon from '../../../../_metronic/helpers/components/FAIcon'

type TableCustomHeaderProps<T extends object> = {
  className?: string
  title?: string | ReactNode
  tableProps: PropsWithChildren<HeaderProps<T>>
  useQueryRequest?: () => {state: any}
  isActionColumn?: boolean
  showTooltip?: boolean
  tooltipContent?: string
}

const TableCustomHeader = <T extends object>({
  className,
  title,
  tableProps,
  useQueryRequest,
  isActionColumn = false,
  showTooltip = false,
  tooltipContent,
}: TableCustomHeaderProps<T>) => {
  const {column} = tableProps
  const {state} = useQueryRequest?.() ?? {state: {}}

  const isSorted = column.isSorted
  const isSortedDesc = column.isSortedDesc
  const canSort = column.canSort

  const isDefaultSortedColumn = column.id === state.sort
  const defaultSortOrder = state.order

  return (
    <th
      {...column.getHeaderProps(column.getSortByToggleProps())}
      className={clsx(className, 'text-uppercase vertical-align-middle')}
    >
      <div className={`header-content-wrapper ${isActionColumn ? 'justify-content-end' : ''}`}>
        {typeof title === 'string' ? (
          <span className='d-inline-flex align-items-center gap-1'>
            {title}
            {showTooltip && tooltipContent && (
              <CustomTooltip 
                message={tooltipContent} 
                position='top'
                customStyles={{textTransform: 'none'}}
              >
                <FAIcon icon={faInfoCircle} className='cursor-pointer page-info-icon' />
              </CustomTooltip>
            )}
          </span>
        ) : (
          <span className='d-inline-flex align-items-center gap-1'>
            {title}
          </span>
        )}
        {canSort && getSortIcon(isSorted, isSortedDesc, isDefaultSortedColumn, defaultSortOrder)}
      </div>
    </th>
  )
}

export {TableCustomHeader}
